import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IconName } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { useCurrentProfileId } from '@mews-commander/core';
import { hasCurrentEnterpriseServiceProviderMode } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    isCurrentProfilePlatformAdmin,
    canCurrentProfileConfigureEnterprise,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

const ExportsMenu = ({ isPlatformAdmin, hasServiceProviderMode, canConfigureEnterprise, ...other }: $TSFixMe) => {
    const ownerId = useCurrentProfileId();
    const exportViewsV2Enabled = useFeatureFlag(FeatureFlag.exportViewsV2Enabled);
    if (!isPlatformAdmin && !hasServiceProviderMode && !canConfigureEnterprise) {
        return null;
    }
    const exportsTitle = exportViewsV2Enabled ? TextKey.AllExports : TextKey.Archive;

    return (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.Exports} />}
            primaryText={<LocalizedText textKey={TextKey.ExportPlural} />}
            {...other}
        >
            {createListItemWithLink({
                textKey: exportsTitle,
                iconName: IconName.Archive,
                path: 'Export/Index',
            })}
            {!exportViewsV2Enabled &&
                createListItemWithLink({
                    textKey: TextKey.Schedules,
                    iconName: IconName.Schedules,
                    path: 'ExportSchedule/Index',
                    search: { OwnerId: ownerId },
                })}
            {createListItemWithLink({
                textKey: TextKey.Targets,
                iconName: IconName.Targets,
                path: 'ExportTarget/Index',
                search: { OwnerId: ownerId },
            })}
        </SidebarExpandableListItem>
    );
};

export default connect(
    createStructuredSelector({
        isPlatformAdmin: isCurrentProfilePlatformAdmin,
        hasServiceProviderMode: hasCurrentEnterpriseServiceProviderMode,
        canConfigureEnterprise: canCurrentProfileConfigureEnterprise,
    })
)(ExportsMenu);
